(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4645],{

/***/ 24645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26538);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49794);
/* harmony import */ var _developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56399);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39181);






var DevelopersChoose = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), selectedBenefit = ref[0], setSelectedBenefit = ref[1];
    // Benefits data based on Figma design
    var benefits = [
        {
            title: "Faster Development",
            description: "VxFX streamlines the plugin creation process, reducing development time by up to 80% through a unified, cross-platform codebase."
        },
        {
            title: "Simplified Maintenance",
            description: "Manage, update, and optimize all plugin versions from a single source without rewriting code for different hosts or GPU architectures."
        },
        {
            title: "Future-Proof Innovation",
            description: "Stay ahead of evolving hardware and software with a framework designed for long-term compatibility, giving you more freedom to focus on creativity and performance."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsContent),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsHeader),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_5__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                variant: "text-md",
                                color: "grayDark-300",
                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsSubtitle),
                                children: "Benefits"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_5__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                variant: "display-lg",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsTitle),
                                children: "Why Developers Choose VxFX"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_5__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                variant: "text-lg",
                                color: "grayDark-400",
                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsDescription),
                                children: "Simplify development, boost efficiency, and ensure lasting compatibility across platforms."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsMain),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsLeft),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsList),
                                children: benefits.map(function(benefit, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_5__/* .Fade */ .pT, {
                                        triggerOnce: true,
                                        duration: 1000,
                                        delay: index * 200,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitItem), " ").concat(selectedBenefit === index ? (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().selected) : ""),
                                            onClick: function() {
                                                return setSelectedBenefit(index);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitContent),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-lg",
                                                        as: "h3",
                                                        color: "grayDark-50",
                                                        weight: "semibold",
                                                        className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitTitle),
                                                        children: benefit.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-md",
                                                        color: "grayDark-400",
                                                        className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitDescription),
                                                        children: benefit.description
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsRight),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().benefitsGraphic),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/product-benefit.jpg",
                                        alt: "Why Developers Choose VxFX - Faster Development, Simplified Maintenance, and Future-Proof Innovation",
                                        className: (_developerschoose_module_scss__WEBPACK_IMPORTED_MODULE_4___default().graphicImage),
                                        width: 1024,
                                        height: 1024,
                                        layout: "responsive"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DevelopersChoose);


/***/ }),

/***/ 49794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"benefitsContainer":"developerschoose_benefitsContainer__59tXN","benefitsContent":"developerschoose_benefitsContent__0n10A","benefitsHeader":"developerschoose_benefitsHeader__tEJhb","benefitsTitle":"developerschoose_benefitsTitle__wLHMk","benefitsMain":"developerschoose_benefitsMain__ZMtHb","benefitsLeft":"developerschoose_benefitsLeft__dqo_g","benefitsList":"developerschoose_benefitsList__yP9GZ","benefitItem":"developerschoose_benefitItem__sfaLE","selected":"developerschoose_selected__Zv8Z_","benefitContent":"developerschoose_benefitContent__Bdc4W","benefitsRight":"developerschoose_benefitsRight__5XfTC","benefitsGraphic":"developerschoose_benefitsGraphic__dD6Z0"};

/***/ })

}]);